import { useState } from "react";
import { useDispatch } from "react-redux";
import { addBook, fetchBook } from "../../redux/slices/booksSlice";
import booksData from "../../data/books.json";
import "./BookForm.css";
import createBookWithID from "../../utils/CreateBookWithID";

const BookForm = () => {
   const [title, setTitle] = useState("");
   const [author, setAuthor] = useState("");
   const dispatch = useDispatch();

   const handelSubmit = (e) => {
      e.preventDefault();
      if (title && author) {
         dispatch(addBook(createBookWithID({ title, author }, "manual")));
         setAuthor("");
         setTitle("");
      }
   };

   const addRandomBookHendler = () => {
      const randomIndex = Math.floor(Math.random() * booksData.length);
      const randomBook = booksData[randomIndex];

      dispatch(addBook(createBookWithID(randomBook, "random")));
   };

   const addRandomBookViaAPIHendler = () => {
      dispatch(fetchBook());
   };

   return (
      <div className="app-block book-form">
         <h2>Add a new book</h2>
         <form onSubmit={handelSubmit}>
            <div>
               <label htmlFor="title">Title: </label>
               <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  id="title"
               />
            </div>
            <div>
               <label htmlFor="author">Author: </label>
               <input
                  type="text"
                  id="author"
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
               />
            </div>
            <button type="submit">Add book</button>
            <button onClick={addRandomBookHendler}>Add random</button>
            <button type="button" onClick={addRandomBookViaAPIHendler}>
               Add random via API
            </button>
         </form>
      </div>
   );
};

export default BookForm;
